export default __webpack_public_path__ + "static/media/482653__joao-janz__bonus-points-1-1.2d63ad61.mp3";